import { render, staticRenderFns } from "./ClusterSupplierSelector.vue?vue&type=template&id=b70ea660&scoped=true"
import script from "./ClusterSupplierSelector.vue?vue&type=script&lang=js"
export * from "./ClusterSupplierSelector.vue?vue&type=script&lang=js"
import style0 from "./ClusterSupplierSelector.vue?vue&type=style&index=0&id=b70ea660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70ea660",
  null
  
)

export default component.exports